import { render, staticRenderFns } from "./DashboardInspection.vue?vue&type=template&id=6f782cb4&scoped=true&"
import script from "./DashboardInspection.vue?vue&type=script&lang=js&"
export * from "./DashboardInspection.vue?vue&type=script&lang=js&"
import style0 from "../InputPPM/DashboardPPCM.scss?vue&type=style&index=0&id=6f782cb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f782cb4",
  null
  
)

export default component.exports